export const eventTempData = {
  success: true,
  pagination: {
    page: 1,
    size: 20,
    offset: 0,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 1,
    first: true,
    last: true,
  },
  data: [
    {
      eventSid: 1,
      eventTypeCd: {
        // code: 'domestic_ir',
        code: 11,
        pcode: 101,
        value: '국내 IR',
      },
      startDt: 1711497600000, // 2024-03-27
      location: '서울 여의도 본사 대회의실',
      title: '2024년 1분기 국내 기관투자자 대상 IR',
      desc: '국내 주요 기관투자자들을 대상으로 하는 2024년 1분기 실적 및 향후 전망 발표',
      regDt: 1710864000000, // 2024-03-20
    },
    {
      eventSid: 2,
      eventTypeCd: {
        // code: 'domestic_ndr',
        code: 11,
        pcode: 101,
        value: '국내 NDR',
      },
      startDt: 1711584000000, // 2024-03-28
      location: '부산 해운대구 센텀시티',
      title: '부산 지역 투자자 NDR',
      desc: '부산 지역 주요 기관 투자자 방문 및 기업설명회 진행',
      regDt: 1710864000000, // 2024-03-20
    },
    {
      eventSid: 3,
      eventTypeCd: {
        // code: 'earnings_announcement',
        code: 33,
        value: '경영 실적 발표',
        pcode: 101,
      },
      startDt: 1712534400000, // 2024-04-08
      location: '서울 여의도 콘래드호텔',
      title: '2024년 1분기 실적발표회',
      desc: '2024년 1분기 실적 발표 및 향후 사업계획 공유',
      regDt: 1710864000000, // 2024-03-20
    },
    {
      eventSid: 4,
      eventTypeCd: {
        // code: 'domestic_ir',
        code: 11,
        value: '국내 IR',
        pcode: 101,
      },
      startDt: 1712793600000, // 2024-04-11
      location: '대전 유성구 대덕테크노밸리',
      title: '대전 지역 기관투자자 IR',
      desc: '대전 지역 주요 기관투자자 대상 기업설명회 및 연구소 투어',
      regDt: 1710864000000, // 2024-03-20
    },
  ],
};
export const historyData = {
  success: true,
  pagination: {
    page: 1,
    size: 20,
    offset: 0,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 1,
    first: true,
    last: true,
  },
  data: [
    {
      historySid: 1,
      historyDate: 1072886400000, // 2004-01-01
      titleKo: '회사 설립',
      titleEn: 'Company Establishment',
      desc: '주식회사 ABC 설립',
      regUser: {
        oprtrSid: 1,
        loginId: 'admin1',
        oprtrNm: '김관리',
      },
      updUser: null,
      regDt: 1710864000000, // 2024-03-20
      updDt: null,
    },
    {
      historySid: 2,
      historyDate: 1293811200000, // 2011-01-01
      titleKo: '기업부설연구소 설립',
      titleEn: 'R&D Center Establishment',
      desc: '기업부설연구소 인증 획득 및 연구소 설립',
      regUser: {
        oprtrSid: 1,
        loginId: 'admin1',
        oprtrNm: '김관리',
      },
      updUser: null,
      regDt: 1710864000000, // 2024-03-20
      updDt: null,
    },
    {
      historySid: 3,
      historyDate: 1672498800000, // 2023-01-01
      titleKo: '매출 1000억 달성',
      titleEn: 'Achieved 100 Billion KRW in Sales',
      desc: '연간 매출 1000억원 달성 및 우수 기업 선정',
      regUser: {
        oprtrSid: 1,
        loginId: 'admin1',
        oprtrNm: '김관리',
      },
      updUser: null,
      regDt: 1710864000000, // 2024-03-20
      updDt: null,
    },
  ],
};
export const popupData = {
  success: true,
  pagination: {
    page: 1,
    size: 20,
    offset: 0,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 1,
    first: true,
    last: true,
  },
  data: [
    {
      popupSid: 1,
      title: '2024 봄 이벤트 안내',
      desc: '<p>봄맞이 특별 이벤트 안내입니다.</p>',
      useYn: true,
      startDt: 1711065600000, // 2024-03-22
      endDt: 1711324800000, // 2024-03-25
      width: 400,
      height: 500,
      environment: 'mobile',
      displayHours: 24,
      topPosition: 100,
      leftPosition: 100,
      regUser: {
        oprtrSid: 1,
        loginId: 'admin1',
        oprtrNm: '김관리',
      },
      updUser: null,
      regDt: 1710864000000, // 2024-03-20
      updDt: null,
    },
    {
      popupSid: 2,
      title: '시스템 점검 안내',
      desc: '<p>시스템 점검이 진행될 예정입니다.</p>',
      useYn: true,
      startDt: 1711152000000, // 2024-03-23
      endDt: 1711238400000, // 2024-03-24
      width: 350,
      height: 450,
      environment: 'web',
      displayHours: 48,
      topPosition: 150,
      leftPosition: 150,
      regUser: {
        oprtrSid: 2,
        loginId: 'admin2',
        oprtrNm: '김관리2',
      },
      updUser: null,
      regDt: 1710950400000, // 2024-03-21
      updDt: null,
    },
  ],
};
export const businessData = {
  success: true,
  pagination: {
    page: 1,
    size: 20,
    offset: 0,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 1,
    first: true,
    last: true,
  },
  data: [
    {
      businessSid: 1,
      bnCatCd: 3,
      bnSubCatCd: 3,
      pipelineCd: 'Launch',
      title: '닥터진 니코지니',
      useYn: true,
      delYn: false,
      ordr: 1,
      summary:
        '닥터진 니코지니는 니코틴 사용장애 환자의 니코틴 의존 증상을 개선하기 위한 인지치료 소프트웨어 (E06060.02 2등급) 입니다.',
      descript: '',
      link: 'https://example.com/ai-healthcare',
      thumbPath: '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
      detailPath: [
        '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
        '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
      ],
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 2, loginId: 'editor', oprtrNm: 'Editor User' },
      lang: 'ko',
      subContentInfos: [
        {
          title:
            '개인 맞춤형 금연치료 프로그램을 제공하는 챗봇과 흡연갈망 극복 프로그램으로 구성된 디지털 치료기 (DTx)',
          descript:
            '개인/의료진 모니터링을 기반으로 금연 실패를 예측하는 기능을 탑재하여 실패가 예측되었을 시 조기 개입을 통해 관리, 치료 관리까지 제공',
          desktopImagePath: [
            '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
            '/upload/news/2024/10/28/20241128155847_보도자료2.jpg',
          ],
          mobileImagePath: [
            '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
            '/upload/news/2024/10/28/20241128155847_보도자료2.jpg',
          ],
        },
        {
          title: '헬스케어 데이터 활용',
          descript: '헬스케어 데이터의 수집 및 분석 방법을 설명합니다.',
          desktopImagePath: [
            '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
            '/upload/news/2024/10/28/20241128155847_보도자료2.jpg',
          ],
          mobileImagePath: [
            '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
            '/upload/news/2024/10/28/20241128155847_보도자료2.jpg',
          ],
        },
      ],
    },
    {
      businessSid: 2,
      bnCatCd: 5,
      bnSubCatCd: 5,
      pipelineCd: 'Store',
      title: '닥터진 니코지니',
      useYn: true,
      delYn: false,
      ordr: 1,
      summary:
        '닥터진 니코지니는 니코틴 사용장애 환자의 니코틴 의존 증상을 개선하기 위한 인지치료 소프트웨어 (E06060.02 2등급) 입니다.',
      descript: '',
      link: 'https://example.com/ai-healthcare',
      thumbPath:
        '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
      detailPath: [
        '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
        '/upload/visual/2024/10/20/20241120092650_스크린샷 2024-11-19 오후 1.27.17.png',
      ],
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 2, loginId: 'editor', oprtrNm: 'Editor User' },
      lang: 'ko',
      subContentInfos: [
        {
          title:
            '개인 맞춤형 금연치료 프로그램을 제공하는 챗봇과 흡연갈망 극복 프로그램으로 구성된 디지털 치료기 (DTx)',
          descript:
            '개인/의료진 모니터링을 기반으로 금연 실패를 예측하는 기능을 탑재하여 실패가 예측되었을 시 조기 개입을 통해 관리, 치료 관리까지 제공',
          desktopImagePath: [
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
          ],
          mobileImagePath: [
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
          ],
        },
        {
          title: '헬스케어 데이터 활용',
          descript: '헬스케어 데이터의 수집 및 분석 방법을 설명합니다.',
          desktopImagePath: [
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
          ],
          mobileImagePath: [
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
            '/upload/visual/2024/10/20/20241120092610_샘플2.jpg',
          ],
        },
      ],
    },
  ],
};
export const mainVisualData = [
  {
    id: 1,
    basckgroundImage: 'src/assets/images/main-visual/1.jpg',
    mainText: 'mainText1',
    subText1: 'subText1',
    subText2: 'subText2',
    order: 2,
    useYn: true,
    regUser: null,
    updUser: null,
    regDt: new Date().getTime(),
    updDt: new Date().getTime(),
  } as unknown,
  {
    id: 2,
    basckgroundImage: 'src/assets/images/main-visual/1.jpg',
    mainText: 'mainText1',
    subText1: 'subText1',
    subText2: 'subText2',
    order: 1,
    useYn: true,
    regUser: null,
    updUser: null,
    regDt: new Date().getTime(),
    updDt: new Date().getTime(),
  } as unknown,
];
export const categoryData = {
  success: true,
  data: [
    {
      categorySid: 1,
      categoryNm: 'HealthCare',
      pCategory: null,
      useYn: true,
      order: 1,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle:
        '이너웨이브의 헬스케어 사업은 의료기기, 모바일 헬스, AI 질환 예측 시스템을 포함한 다양한 헬스케어 서비스를 제공하는 종합적인 헬스케어 서비스입니다.',
      subTitle: '',
      mainDesc: '',
      subDesc: '',
      pipeline: null,
      pipelineList: null,
    },
    {
      categorySid: 2,
      categoryNm: 'ICT',
      pCategory: null,
      useYn: true,
      order: 2,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle:
        '이너웨이브는 AI, 빅데이터, 클라우드 기술을 통합하여 혁신적인 ICT 플랫폼을 구축하며, 고객의 비즈니스 성장을 지원하는 최적화된 솔루션을 제공합니다',
      subTitle: '',
      mainDesc: '',
      subDesc: '',
      pipeline: null,
      pipelineList: null,
    },
    {
      categorySid: 3,
      categoryNm: '디지털 의료기기',
      pCategory: 1,
      useYn: true,
      order: 3,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '분야별 전문 의료진과 함께하는',
      subTitle: '디지털 치료기기(DTx)',
      mainDesc:
        '이너웨이브는 의료기기 GMP 인증과 임상시험 승인을 통해 검증된 치료제를 제공하여 언제 어디서든 건강 관리에 기여하고 있습니다.',
      subDesc:
        '의학적 장애나 질병을 예방·관리·치료하기 위해 근거 기반의 치료적 개입을 제공하는 4세대 소프트웨어 의료기기로, 의사의 처방을 통해 사용되며 임상시험으로 안전성과 유효성을 입증받아야 합니다.',
      pipeline: 'DTx-Product Pipeline',
      pipelineList: `Discovery\nProof of Concept\nPivotal Trial\nProduct Approval\nLaunch\n`,
    },
    {
      categorySid: 4,
      categoryNm: 'AI 질환 진단예측',
      pCategory: 1,
      useYn: true,
      order: 4,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '분야별 전문 의료진과 함께하는',
      subTitle: 'AI 질환 진단 예측',
      mainDesc:
        '중환자실 환자의 저혈압과 임신 합병증 및 자연 분만 성공 여부를 사전 예측하여 고위험 질환을 선제적으로 관리하고, 안심할 수 있는 의료 경험을 제공합니다.',
      subDesc:
        '인공지능(AI) 기술을 활용한 이너웨이브의 AI 플랫폼은 전문 의료진과 협력하여 개발되었으며, 개별 질병에 특화된 예측 AI를 통해 고위험 질환 발병을 예측하고 차별화된 질환 관리와 예방 서비스를 제공합니다.',
      pipeline: 'Predictive Product Pipeline',
      pipelineList: `Discovery\nProof of Concept\nPivotal Trial\nProduct Approval\nLaunch\n`,
    },
    {
      categorySid: 5,
      categoryNm: '마이크로 바이옴',
      pCategory: 1,
      useYn: true,
      order: 4,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '차세대 염기서열 분석 기술과 함께하는',
      subTitle: '마이크로바이옴 서비스',
      mainDesc:
        '질환 종합 결과를 제공하여 개인의 건강 유지에 최적화된 맞춤형 서비스를 제공하며, 우리 몸에 함께 살아가는 미생물 생태계의 건강을 유지하기 위해 연구를 통해 밝혀진 "질병과 미생물의 관계"를 분석하여 다양한 질병에 대한 위험도를 예측할 수 있습니다.',
      subDesc:
        '2024년 4분기 국내 모바일 스토어 오픈과 함께 서비스가 출시될 예정이며, 2025년 1분기부터 동남아, 인도, 중동 등지에 순차적으로 서비스가 런칭될 예정입니다.',
      pipeline: 'Microbiome Service Pipeline',
      pipelineList: `Discovery\nDevelop\nStore\nService Launch`,
    },
    {
      categorySid: 6,
      categoryNm: 'Patient Portal',
      pCategory: 1,
      useYn: true,
      order: 4,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '예약부터 검사결과까지 한 번에',
      subTitle: 'Patient Portal',
      mainDesc:
        '병원 진료 예약과 진료비 결제, 검사결과 조회를 한 번에 할 수 있는 맞춤형 소통 서비스입니다.',
      subDesc: '',
      pipeline: null,
      pipelineList: null,
    },
    {
      categorySid: 7,
      categoryNm: '청소년 안전 교육',
      pCategory: 1,
      useYn: true,
      order: 5,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '',
      subTitle: '',
      mainDesc: '',
      subDesc: '',
      pipeline: null,
      pipelineList: null,
    },
    {
      categorySid: 8,
      categoryNm: 'Guardiant AI',
      pCategory: 2,
      useYn: true,
      order: 1,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '',
      subTitle: '',
      mainDesc: '',
      subDesc: '',
      pipeline: null,
      pipelineList: null,
    },
    {
      categorySid: 9,
      categoryNm: 'MBS',
      pCategory: 2,
      useYn: true,
      order: 2,
      lang: 'ko',
      regDt: 1698988800000,
      updDt: 1698992400000,
      regUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      updUser: { oprtrSid: 1, loginId: 'admin', oprtrNm: 'Admin User' },
      mainTitle: '',
      subTitle: '',
      mainDesc: '',
      subDesc: '',
      pipeline: null,
      pipelineList: null,
    },
  ],
};
